import { CurrencyPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '@shared/components/general/loader/loader.component';
import { ReactionSummaryData } from '@shared/interfaces';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
    selector: 'app-order-reaction-summary',
    standalone: true,
    imports: [LoaderComponent, DividerModule, TranslateModule, FieldsetModule, CurrencyPipe, NgClass],
    templateUrl: './order-reaction-summary.component.html',
    styleUrls: ['./order-reaction-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderReactionSummaryComponent {
    readonly reactions = input.required<ReactionSummaryData[]>();
    readonly fieldsetColor = input.required<'green' | 'red'>();
    readonly numberOfReactions = input.required<number>();
    readonly id = input<string>('reaction-summary');
    readonly isForCancelled = input<boolean>(false);
}
